<div class="">
    <div class="p-grid  p-fluid">
        <div class="p-md-4 p-p-3">
            <div class="card">
                <form  (ngSubmit)="editProfile()" #profileForm="ngForm">
                    <h5>Profile</h5>
                    <afm-input [(ngModel)]='user.login' label='Login' name='login'></afm-input>
                    <afm-input  [(ngModel)]='user.name' label='Name' name='name'></afm-input>
                    <afm-input [(ngModel)]='user.email' label='Email' name='email'></afm-input>
                    <afm-input [(ngModel)]='user.phone' label='Phone' required='true' name='phone' type='tel'></afm-input>
                    <afm-input [(ngModel)]='user.mobile' label='Mobile' name='mobile' type='tel'></afm-input>
                    <div class="p-grid p-mt-5">
                        <div class="p-md-6">
                            <button pButton [disabled]="!profileForm.valid" type="submit" 
                                    label="Save" icon="pi pi-check" iconPos="left" 
                                    class="p-button-success"></button>
                        </div>
                        <div class="p-md-6">
                            <button pButton  type="button" (click)="reset()"
                                    label="Reset" icon="pi pi-cancel" iconPos="left" 
                                    class="p-button-danger"></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="p-md-4 p-p-3">
            <div class="card">
                <form  (ngSubmit)="editPassWord()" #passwordForm="ngForm">
                    <h5>Change Password</h5>
                    <afm-input [(ngModel)]='user.oldPassword' required="true" label='Old Password' name='oldpassword' type='password'></afm-input>
                    <afm-input  [(ngModel)]='user.newPassword' required="true" label='New Password' name='newpassword' type='password'></afm-input>
                    <afm-input [(ngModel)]='user.newPassword2' required="true" label='Repeat New Password' name='newpassword2' type='password'></afm-input>
                    <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
                    <div class="p-grid p-mt-5">
                        <div class="p-md-6">
                        </div>
                        <div class="p-md-6">
                            <button pButton  type="submit" [disabled]="!passwordForm.valid"
                                    label="Edit Password" icon="pi pi-user" iconPos="left" 
                                    ></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="p-md-4 p-p-3">
            <div class="card">
                <h5>Preferences</h5>
            </div>
        </div>
    </div>

</div>